import { DELIVERY_STATES } from '../../../lib/deliveryStates';

// The delivery states whose titular may still be changed — «Cambiar titular» hands a parcel that is
// physically in the «buzón» to a different «Usuario». `expired` is INCLUDED, unlike in
// `isRestorable`: an expired pickup is still a parcel sitting in the box waiting for whoever owns
// it, and reassigning it is exactly how the wrong owner gets corrected. Every other state means the
// parcel is gone, never arrived, or sits in a problem a reassignment would not fix.
//
// Matched case-insensitively through the canonical constants (the wire is lowercase; older fixtures
// are TitleCase), and FAIL CLOSED: an unrecognized state is not changeable. That direction is the
// deliberate one here. The usual argument runs the other way — an action never offered is a feature
// that does not exist — but this action moves the ownership of a parcel, and offering it on a
// delivery that is already gone spends the agent's call on a backend rejection. The backend rejects
// with `delivery_state_conflict` either way; this keeps the panel from asking.
const CHANGEABLE_STATES = new Set<string>([DELIVERY_STATES.stored, DELIVERY_STATES.expired]);

export function isRecipientChangeable(status: string): boolean {
  return CHANGEABLE_STATES.has(status.toLowerCase());
}
